export default __webpack_public_path__ + "static/media/15.657b16ba.jpg";